const MOCK = {
  kpis: {
    totalRevenue: 2847650,
    revenueGrowth: 12.4,
    activeOrders: 347,
    ordersGrowth: 8.2,
    collectionRate: 94.7,
    collectionGrowth: 2.1,
    activeCustomers: 1243,
    customerGrowth: 5.8,
    pendingDeliveries: 89,
    overdueCollections: 23,
    inventoryAlerts: 7,
    totalVolume: 184320,
  },
  revenueChart: [
    { month: "Jan", revenue: 198, target: 210 },
    { month: "Feb", revenue: 215, target: 210 },
    { month: "Mar", revenue: 231, target: 220 },
    { month: "Apr", revenue: 205, target: 220 },
    { month: "May", revenue: 248, target: 230 },
    { month: "Jun", revenue: 267, target: 230 },
    { month: "Jul", revenue: 289, target: 250 },
    { month: "Aug", revenue: 312, target: 250 },
    { month: "Sep", revenue: 295, target: 270 },
    { month: "Oct", revenue: 334, target: 270 },
    { month: "Nov", revenue: 321, target: 290 },
    { month: "Dec", revenue: 354, target: 290 },
  ],
  collectionChart: [
    { month: "Jan", collected: 185, overdue: 13 },
    { month: "Feb", collected: 202, overdue: 9 },
    { month: "Mar", collected: 218, overdue: 15 },
    { month: "Apr", collected: 197, overdue: 22 },
    { month: "May", collected: 241, overdue: 7 },
    { month: "Jun", collected: 258, overdue: 11 },
    { month: "Jul", collected: 277, overdue: 8 },
    { month: "Aug", collected: 301, overdue: 6 },
    { month: "Sep", collected: 285, overdue: 19 },
    { month: "Oct", collected: 320, overdue: 14 },
    { month: "Nov", collected: 310, overdue: 11 },
    { month: "Dec", collected: 341, overdue: 13 },
  ],
  ordersByProduct: [
    { product: "LPG Bulk", value: 38 },
    { product: "LPG Cylinder", value: 22 },
    { product: "Natural Gas", value: 19 },
    { product: "CNG", value: 13 },
  ],
  customers: [
    {
      id: "C001",
      name: "Petro Industries Ltd",
      type: "Commercial",
      region: "North",
      balance: 45000,
      status: "Active",
      lastOrder: "2026-04-28",
      creditLimit: 100000,
      phone: "+1-555-0101",
      email: "billing@petroindustries.com",
      accountManager: "Alex Morgan",
    },
    {
      id: "C002",
      name: "Metro Gas Station #4",
      type: "Retail",
      region: "Central",
      balance: 12500,
      status: "Active",
      lastOrder: "2026-04-30",
      creditLimit: 30000,
      phone: "+1-555-0102",
      email: "accounts@metrogas.com",
      accountManager: "Lisa Park",
    },
    {
      id: "C003",
      name: "Riverside Manufacturing",
      type: "Industrial",
      region: "South",
      balance: 78900,
      status: "Overdue",
      lastOrder: "2026-04-15",
      creditLimit: 150000,
      phone: "+1-555-0103",
      email: "finance@riverside.com",
      accountManager: "Tom Harris",
    },
    {
      id: "C004",
      name: "City Transport Authority",
      type: "Government",
      region: "Central",
      balance: 23400,
      status: "Active",
      lastOrder: "2026-05-01",
      creditLimit: 200000,
      phone: "+1-555-0104",
      email: "procurement@cta.gov",
      accountManager: "Alex Morgan",
    },
    {
      id: "C005",
      name: "Northern Farms Co-op",
      type: "Agricultural",
      region: "North",
      balance: 8750,
      status: "Active",
      lastOrder: "2026-04-29",
      creditLimit: 25000,
      phone: "+1-555-0105",
      email: "orders@northernfarms.com",
      accountManager: "Lisa Park",
    },
    {
      id: "C006",
      name: "Harbor Shipping Inc",
      type: "Commercial",
      region: "East",
      balance: 156000,
      status: "Overdue",
      lastOrder: "2026-03-20",
      creditLimit: 250000,
      phone: "+1-555-0106",
      email: "accounts@harborshipping.com",
      accountManager: "Tom Harris",
    },
    {
      id: "C007",
      name: "Apex Construction",
      type: "Commercial",
      region: "West",
      balance: 34200,
      status: "Active",
      lastOrder: "2026-04-27",
      creditLimit: 80000,
      phone: "+1-555-0107",
      email: "billing@apexconstruction.com",
      accountManager: "Alex Morgan",
    },
    {
      id: "C008",
      name: "SunPower Energy",
      type: "Industrial",
      region: "South",
      balance: 67800,
      status: "Active",
      lastOrder: "2026-04-26",
      creditLimit: 120000,
      phone: "+1-555-0108",
      email: "finance@sunpower.com",
      accountManager: "Lisa Park",
    },
  ],
  orders: [
    {
      id: "ORD-2026-001",
      customerId: "C001",
      customer: "Petro Industries Ltd",
      product: "2026-01-05",
      qty: 50,
      unitPrice: 2.45,
      total: 12250,
      status: "Delivered",
      date: "2026-04-28",
      delivery: "2026-04-30",
      region: "North",
      driver: "James Wilson",
    },
    {
      id: "ORD-2026-002",
      customerId: "C002",
      customer: "Metro Gas Station #4",
      product: "2026-02-09",
      qty: 200,
      unitPrice: 45.0,
      total: 9000,
      status: "In Transit",
      date: "2026-04-30",
      delivery: "2026-05-02",
      region: "Central",
      driver: "Sarah Chen",
    },
    {
      id: "ORD-2026-003",
      customerId: "C003",
      customer: "Riverside Manufacturing",
      product: "2026-01-15",
      qty: 15,
      unitPrice: 0.85,
      total: 12750,
      status: "Processing",
      date: "2026-05-01",
      delivery: "2026-05-05",
      region: "South",
      driver: "Mike Rodriguez",
    },
    {
      id: "ORD-2026-004",
      customerId: "C004",
      customer: "City Transport Authority",
      product: "2026-02-09",
      qty: 80,
      unitPrice: 1.2,
      total: 9600,
      status: "Confirmed",
      date: "2026-05-01",
      delivery: "2026-05-03",
      region: "Central",
      driver: "Emma Thompson",
    },
    {
      id: "ORD-2026-005",
      customerId: "C005",
      customer: "Northern Farms Co-op",
      product: "2026-01-05",
      qty: 20,
      unitPrice: 2.45,
      total: 4900,
      status: "Pending",
      date: "2026-05-02",
      delivery: "2026-05-06",
      region: "North",
      driver: null,
    },
    {
      id: "ORD-2026-006",
      customerId: "C006",
      customer: "Harbor Shipping Inc",
      product: "2026-02-09",
      qty: 25,
      unitPrice: 1.68,
      total: 42000,
      status: "Cancelled",
      date: "2026-04-25",
      delivery: null,
      region: "East",
      driver: null,
    },
    {
      id: "ORD-2026-007",
      customerId: "C007",
      customer: "Apex Construction",
      product: "2026-01-05",
      qty: 35,
      unitPrice: 2.45,
      total: 8575,
      status: "Delivered",
      date: "2026-04-27",
      delivery: "2026-04-29",
      region: "West",
      driver: "David Park",
    },
    {
      id: "ORD-2026-008",
      customerId: "C008",
      customer: "SunPower Energy",
      product: "Natural Gas",
      qty: 22,
      unitPrice: 0.85,
      total: 18700,
      status: "Confirmed",
      date: "2026-05-02",
      delivery: "2026-05-07",
      region: "South",
      driver: "Rachel Kim",
    },
  ],
  collections: [
    {
      id: "COL-001",
      customerId: "C001",
      customer: "Petro Industries Ltd",
      invoice: "INV-2026-089",
      amount: 25000,
      dueDate: "2026-05-10",
      status: "Pending",
      method: "Bank Transfer",
      collector: "Alex Morgan",
      collectedDate: null,
      notes: "",
    },
    {
      id: "COL-002",
      customerId: "C002",
      customer: "Metro Gas Station #4",
      invoice: "INV-2026-090",
      amount: 9000,
      dueDate: "2026-05-05",
      status: "Collected",
      method: "Cash",
      collector: "Lisa Park",
      collectedDate: "2026-05-01",
      notes: "Paid in full",
    },
    {
      id: "COL-003",
      customerId: "C003",
      customer: "Riverside Manufacturing",
      invoice: "INV-2026-074",
      amount: 78900,
      dueDate: "2026-04-20",
      status: "Overdue",
      method: "Cheque",
      collector: "Tom Harris",
      collectedDate: null,
      notes: "2nd notice sent",
    },
    {
      id: "COL-004",
      customerId: "C004",
      customer: "City Transport Authority",
      invoice: "INV-2026-091",
      amount: 9600,
      dueDate: "2026-05-15",
      status: "Pending",
      method: "Bank Transfer",
      collector: "Alex Morgan",
      collectedDate: null,
      notes: "",
    },
    {
      id: "COL-005",
      customerId: "C005",
      customer: "Northern Farms Co-op",
      invoice: "INV-2026-092",
      amount: 4900,
      dueDate: "2026-05-20",
      status: "Pending",
      method: "Cash",
      collector: "Lisa Park",
      collectedDate: null,
      notes: "",
    },
    {
      id: "COL-006",
      customerId: "C006",
      customer: "Harbor Shipping Inc",
      invoice: "INV-2026-061",
      amount: 156000,
      dueDate: "2026-04-01",
      status: "Overdue",
      method: "Bank Transfer",
      collector: "Tom Harris",
      collectedDate: null,
      notes: "Legal escalation",
    },
    {
      id: "COL-007",
      customerId: "C007",
      customer: "Apex Construction",
      invoice: "INV-2026-085",
      amount: 8575,
      dueDate: "2026-05-08",
      status: "Partial",
      method: "Cash",
      collector: "Alex Morgan",
      collectedDate: "2026-05-01",
      notes: "Partial $4000 paid",
    },
    {
      id: "COL-008",
      customerId: "C008",
      customer: "SunPower Energy",
      invoice: "INV-2026-088",
      amount: 18700,
      dueDate: "2026-05-12",
      status: "Pending",
      method: "Bank Transfer",
      collector: "Tom Harris",
      collectedDate: null,
      notes: "",
    },
  ],
  inventory: [
    {
      id: "INV-001",
      product: "LPG cylinder 48kg",
      sku: "LPG-BLK-001",
      unit: "cylinders",
      stock: 125,
      minStock: 50,
      maxStock: 300,
      location: "Tank A",
      site: "Sky Hill",
      lastRefill: "2026-04-25",
      status: "Sufficient",
      supplier: "PetroGas Corp",
    },
    {
      id: "INV-002",
      product: "LPG Cylinder 48kg",
      sku: "LPG-CYL-013",
      unit: "cylinders",
      stock: 120,
      minStock: 100,
      maxStock: 500,
      location: "Warehouse B",
      site: "Moonstone",
      lastRefill: "2026-04-20",
      status: "Sufficient",
      supplier: "CylTech Ltd",
    },
    {
      id: "INV-003",
      product: "Natural Gas",
      sku: "NAT-GAS-001",
      unit: "cylinders",
      stock: 18,
      minStock: 20,
      maxStock: 300,
      location: "Grid",
      site: "Sasol",
      lastRefill: "2026-04-28",
      status: "Critical",
      supplier: "NatGrid Supply",
    },
    {
      id: "INV-004",
      product: "Oxygen 22.5kg",
      sku: "OXY-STD-001",
      unit: "cylinders",
      stock: 185,
      minStock: 100,
      maxStock: 500,
      location: "Station 1",
      site: "Moonstone",
      lastRefill: "2026-04-26",
      status: "Low",
      supplier: "CompressAir Inc",
    },
    {
      id: "INV-006",
      product: "LPG Cylinder 48kg",
      sku: "LPG-CYL-048",
      unit: "cylinders",
      stock: 85,
      minStock: 100,
      maxStock: 500,
      location: "Warehouse B",
      site: "Sasol",
      lastRefill: "2026-04-15",
      status: "Critical",
      supplier: "CylTech Ltd",
    },
    {
      id: "INV-007",
      product: "Propane cylinder 22.5kg",
      sku: "PRP-BLK-001",
      unit: "cylinders",
      stock: 95,
      minStock: 100,
      maxStock: 500,
      location: "Tank D",
      site: "Sky Hill",
      lastRefill: "2026-04-22",
      status: "Sufficient",
      supplier: "PetroGas Corp",
    },
  ],
  deliveries: [
    {
      id: "DEL-001",
      orderId: "ORD-2026-001",
      customer: "Petro Industries Ltd",
      driver: "James Wilson",
      vehicle: "TRK-045",
      route: "North-A",
      scheduledDate: "2026-04-30",
      status: "Delivered",
      region: "North",
      km: 45,
    },
    {
      id: "DEL-002",
      orderId: "ORD-2026-002",
      customer: "Metro Gas Station #4",
      driver: "Sarah Chen",
      vehicle: "TRK-032",
      route: "Central-B",
      scheduledDate: "2026-05-02",
      status: "In Transit",
      region: "Central",
      km: 22,
    },
    {
      id: "DEL-003",
      orderId: "ORD-2026-003",
      customer: "Riverside Manufacturing",
      driver: "Mike Rodriguez",
      vehicle: "TRK-018",
      route: "South-C",
      scheduledDate: "2026-05-05",
      status: "Scheduled",
      region: "South",
      km: 78,
    },
    {
      id: "DEL-004",
      orderId: "ORD-2026-004",
      customer: "City Transport Authority",
      driver: "Emma Thompson",
      vehicle: "TRK-067",
      route: "Central-A",
      scheduledDate: "2026-05-03",
      status: "Scheduled",
      region: "Central",
      km: 15,
    },
    {
      id: "DEL-005",
      orderId: "ORD-2026-005",
      customer: "Northern Farms Co-op",
      driver: null,
      vehicle: null,
      route: "North-B",
      scheduledDate: "2026-05-06",
      status: "Unassigned",
      region: "North",
      km: 92,
    },
    {
      id: "DEL-006",
      orderId: "ORD-2026-008",
      customer: "SunPower Energy",
      driver: "Rachel Kim",
      vehicle: "TRK-091",
      route: "South-A",
      scheduledDate: "2026-05-07",
      status: "Scheduled",
      region: "South",
      km: 63,
    },
  ],
  accounts: [
    {
      id: "ACC-001",
      customerId: "C001",
      customer: "Petro Industries Ltd",
      creditLimit: 100000,
      usedCredit: 45000,
      paymentTerms: "Net 30",
      rating: "A",
      status: "Good",
      openInvoices: 2,
      totalOutstanding: 45000,
    },
    {
      id: "ACC-002",
      customerId: "C002",
      customer: "Metro Gas Station #4",
      creditLimit: 30000,
      usedCredit: 12500,
      paymentTerms: "Net 15",
      rating: "B",
      status: "Good",
      openInvoices: 1,
      totalOutstanding: 12500,
    },
    {
      id: "ACC-003",
      customerId: "C003",
      customer: "Riverside Manufacturing",
      creditLimit: 150000,
      usedCredit: 78900,
      paymentTerms: "Net 45",
      rating: "D",
      status: "Overdue",
      openInvoices: 3,
      totalOutstanding: 78900,
    },
    {
      id: "ACC-004",
      customerId: "C004",
      customer: "City Transport Authority",
      creditLimit: 200000,
      usedCredit: 23400,
      paymentTerms: "Net 60",
      rating: "A",
      status: "Good",
      openInvoices: 1,
      totalOutstanding: 23400,
    },
    {
      id: "ACC-005",
      customerId: "C006",
      customer: "Harbor Shipping Inc",
      creditLimit: 250000,
      usedCredit: 156000,
      paymentTerms: "Net 30",
      rating: "F",
      status: "Blocked",
      openInvoices: 5,
      totalOutstanding: 156000,
    },
    {
      id: "ACC-006",
      customerId: "C007",
      customer: "Apex Construction",
      creditLimit: 80000,
      usedCredit: 34200,
      paymentTerms: "Net 30",
      rating: "B",
      status: "Good",
      openInvoices: 2,
      totalOutstanding: 34200,
    },
  ],
  notifications: [
    {
      id: 1,
      type: "alert",
      title: "Critical Stock Alert",
      message: "LPG Cylinder 48kg below minimum threshold",
      time: "5m ago",
      read: false,
    },
    {
      id: 2,
      type: "overdue",
      title: "Overdue Collection",
      message: "Harbor Shipping — $156,000 overdue by 31 days",
      time: "1h ago",
      read: false,
    },
    {
      id: 3,
      type: "order",
      title: "New Order Received",
      message: "ORD-2026-005 from Northern Farms Co-op — $4,900",
      time: "2h ago",
      read: false,
    },
    {
      id: 4,
      type: "delivery",
      title: "Delivery Completed",
      message: "DEL-001 delivered to Petro Industries Ltd ✓",
      time: "3h ago",
      read: true,
    },
    {
      id: 5,
      type: "warning",
      title: "Low Stock Warning",
      message: "Natural Gas below minimum — 18,000 m³ remaining",
      time: "4h ago",
      read: true,
    },
    {
      id: 6,
      type: "order",
      title: "Order Status Updated",
      message: "ORD-2026-002 is now In Transit — Sarah Chen driving",
      time: "5h ago",
      read: true,
    },
  ],
};

export { MOCK };
